import { FunctionComponent } from 'react';
import { Input } from '../../UI/V3/Forms/Input/Input';
import Button from '../../UI/V3/Button/Button';
import PhoneField3 from 'components/UI/PhoneField3';
import { DuplicateLocationDetails } from '../../../model/location';
import { DuplicateDetailsField, DuplicateFieldErrors } from './duplicateLocationValidation';
import styles from './DuplicateLocationModal.module.scss';

interface DuplicateLocationDetailsStepProps {
    sourceName: string;
    details: DuplicateLocationDetails;
    fieldErrors: DuplicateFieldErrors;
    generalError?: string;
    onChange: (field: DuplicateDetailsField, value: string) => void;
    onContinue: () => void;
}

export const DuplicateLocationDetailsStep: FunctionComponent<DuplicateLocationDetailsStepProps> = ({
    sourceName,
    details,
    fieldErrors,
    generalError,
    onChange,
    onContinue
}) => {
    return (
        <>
            <h2 className={styles.title}>Duplicate location</h2>
            <p className={styles.subtitle}>
                Create a new location from <b>{sourceName}</b>. Enter the details of the new location.
            </p>

            {generalError && <p className={styles.generalError}>{generalError}</p>}

            <div className={styles.formField}>
                <Input
                    id="duplicateBusinessName"
                    label="Location name"
                    value={details.businessName}
                    onChange={e => onChange('businessName', e.target.value)}
                    placeholder="Enter location name"
                    error={fieldErrors.businessName}
                />
            </div>

            <div className={styles.formRow}>
                <div className={styles.formField}>
                    <Input
                        id="duplicateEmail"
                        label="Work email"
                        type="email"
                        value={details.email}
                        onChange={e => onChange('email', e.target.value)}
                        placeholder="Enter work email"
                        error={fieldErrors.email}
                    />
                </div>
                <div className={styles.formField}>
                    <PhoneField3
                        id="duplicatePhone"
                        name="phone"
                        label="Phone number"
                        value={details.phone}
                        onChange={value => onChange('phone', value)}
                        placeholder="(___) ___-____"
                        errors={
                            fieldErrors.phone ? [{ fieldName: 'phone', errorMessage: fieldErrors.phone }] : undefined
                        }
                    />
                </div>
            </div>

            <div className={styles.formField}>
                <Input
                    id="duplicateAddressLineOne"
                    label="Address line 1"
                    value={details.addressLineOne}
                    onChange={e => onChange('addressLineOne', e.target.value)}
                    placeholder="Enter address line 1"
                    error={fieldErrors.addressLineOne}
                />
            </div>

            <div className={styles.formField}>
                <Input
                    id="duplicateAddressLineTwo"
                    label="Address line 2"
                    value={details.addressLineTwo}
                    onChange={e => onChange('addressLineTwo', e.target.value)}
                    placeholder="Enter address line 2 (optional)"
                    error={fieldErrors.addressLineTwo}
                />
            </div>

            <div className={styles.formRow}>
                <div className={styles.formField}>
                    <Input
                        id="duplicateCity"
                        label="City"
                        value={details.city}
                        onChange={e => onChange('city', e.target.value)}
                        placeholder="City"
                        error={fieldErrors.city}
                    />
                </div>
                <div className={styles.formField}>
                    <Input
                        id="duplicateState"
                        label="State"
                        value={details.state}
                        onChange={e => onChange('state', e.target.value)}
                        placeholder="State"
                        error={fieldErrors.state}
                    />
                </div>
                <div className={styles.formField}>
                    <Input
                        id="duplicateZipcode"
                        label="Zipcode"
                        value={details.zipcode}
                        onChange={e => onChange('zipcode', e.target.value)}
                        placeholder="Zipcode"
                        error={fieldErrors.zipcode}
                    />
                </div>
                <div className={styles.formField}>
                    <Input
                        id="duplicateCountry"
                        label="Country"
                        value={details.country}
                        onChange={e => onChange('country', e.target.value)}
                        placeholder="Country"
                        error={fieldErrors.country}
                    />
                </div>
            </div>

            <div className={styles.actions}>
                <Button
                    label="Continue"
                    variant="black"
                    size="large"
                    onClick={onContinue}
                />
            </div>
        </>
    );
};

export default DuplicateLocationDetailsStep;
